<template>
    <v-footer>
    <v-container class="my-0 py-0 hidden-sm-and-down">
    <v-layout row justify="space-between" align="center">
            <v-flex cols="12" md="4" xl="2" lg="3" xs="12" sm="12">
                <v-layout row justify="center">
                    <v-flex sm="1" md="3" class="px-0">
                        <v-btn href="https://www.facebook.com/UdeGuanajuato/" class="mx-1" nuxt fab dark color="#5585bf">
                            <v-icon dark>
                                mdi-facebook-box
                            </v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex sm="1" md="3" class="px-0">
                        <v-btn href="https://twitter.com/UdeGuanajuato" class="mx-1" nuxt fab dark color="#5585bf">
                            <v-icon dark>
                                mdi-twitter
                            </v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex sm="1" md="3" class="px-0">
                        <v-btn href="https://www.youtube.com/user/televisionug" class="mx-1" nuxt fab dark color="#5585bf">
                            <v-icon dark>
                                mdi-youtube
                            </v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex sm="1" md="3" class="px-0">
                        <v-btn href="https://www.instagram.com/udeguanajuato/" class="mx-1" nuxt fab dark color="#5585bf">
                            <v-icon dark>
                                mdi-instagram
                            </v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout >
            </v-flex>
            <v-flex class="text-center ma-0 px-0" cols="12" md="5" xl="4" xs="12" sm="12">
                <p class="body-2 ma-0 x-0 font-italic">
                    Lascuráin de Retana No. 5, Col. Centro C.P. 36000
                    <br>
                    Guanajuato, Gto., México
                    <br>
                    Tel: +52 (473) 732 00 06
                </p>
                <a href="mailto:soporta@ugto.mx" class="body-2 ma-0 font-italic">
                    soporte@ugto.mx
                </a>
            </v-flex>
            <v-flex class="text-center px-0 " cols="12" md="3" xl="2" xs="12" sm="12">
                <v-img max-height="100px" contain aspect-ratio="2" :src="require('@/assets/ug-vert.png')" alt="logo" />
            </v-flex>
        </v-layout >
    
    </v-container>
    
    </v-footer>
</template>

<script>
import {
    mapGetters
} from 'vuex'

export default {
    data: () => ({
        menu: true,
    }),
    computed: {
        ...mapGetters({
        oidcUser:'oidcStore/oidcUser'
        
    })
    
    },

}
</script>
